import React from 'react'

import EmptyReleaseNotes from 'Icons/empty-release-notes.svg'

import NoContent from 'Layout/NoContent'

const noContentProps = {
  heading: 'Publish release notes for your products',
  description: 'Excite your customers by publishing the new features and product updates',
  ctaButtonText: 'Create a release note',
  icon: EmptyReleaseNotes,
  ctaTarget: 'create'
}

const NoReleaseNotes = () => {
  return <NoContent {...noContentProps} />
}

export default NoReleaseNotes
